export default [
  {
    id: 8,
    title: "ابزارآلات",
  },
  {
    id: 9,
    title: "یراق آلات ساختمانی",
  },
  {
    id: 10,
    title: "یراق آلات چوب و دکوراسیون",
  },
  {
    id: 11,
    title: "چسب و روان کننده ها",
  },
  {
    id: 12,
    title: "ماشین آلات صنعتی و راه سازی",
  },
  {
    id: 13,
    title: "پیچ و مهره و اتصالات",
  },
  {
    id: 14,
    title: "تجهیزات الکتریکی",
  },
  {
    id: 16,
    title: "عمومی",
  },
  {
    id: 19,
    title: "درب اتوماتی",
  },

  {
    id: 20,
    title: "رسانه",
  },
  {
    id: 21,
    title: "ادوات نصب",
  },
  {
    id: 22,
    title: "ورزش و سلامتی",
  },

];
